import { ComponentsOverrides, Theme } from "@mui/material";

type TableRow = {
  styleOverrides: ComponentsOverrides<Theme>["MuiTableRow"];
};

const MuiTableRow: TableRow = {
  styleOverrides: {
    root: {
      "&:hover": {
        cursor: "default",
      },
    },
  },
};

export { MuiTableRow };
